import httpClient from './http';
import lodash from 'lodash';

export default {

  getUser: (userId) => {
    return httpClient.get(`/account/${userId}`)
      .then(res => res.data);
  },

  getProduct: (productId) => {
    return httpClient.get(`/api/product/${productId}`)
      .then(res => res.data);
  },

  getBox: (boxId) => {
    return httpClient.get(`/api/box/${boxId}`)
      .then(res => res.data);
  },

  getBoxes: () => {
    return httpClient.get(`/api/boxes`)
      .then(res => res.data);
  },

  getDeliveryFees: () => {
    return httpClient.get(`/api/fees`)
      .then(res => res.data);
  },

  getLikes: () => {
    return httpClient.get(`/api/products/likes`)
      .then(res => res.data);
  },

  getOrders: () => {
    return httpClient.get(`/orders`)
      .then(res => res.data);
  },

  getOrderById: (orderId) => {
    return httpClient.get(`/orders/${orderId}`)
      .then(res => res.data);
  },

  getCartContent: () => {
    return httpClient.get(`/account/cart`)
      .then(res => res.data);
  },

  getTCartContent: async () => {
    let result = await httpClient.get(`/account/t-cart`).then(res => res.data)
    if(result && result.order_items){
      result.order_items = lodash.sortBy(result.order_items, [function(o) { return !o.panier && o.product.order }])
    }
    return result
  },

  getCurrentUser: () => {
    return httpClient.get(`/api/account/current`)
      .then(res => res.data);
  },

  getTodayOrder: () => {
    return httpClient.get(`/api/account/today-order`)
      .then(res => res.data);
  },

  getGlassBalance: () => {
    return httpClient.get(`/api/account/glass-balance`)
      .then(res => res.data);
  },

  /**
   * Order product quantity
   */
  setCartQuantity: (productId, quantity) => {
    return httpClient.put(`/product/${productId}/c_quantity`, {
      quantity
    }).then(res => res.data);
  },

  /**
   * Order box quantity
   */
  setBoxQuantity: (boxId, quantity) => {
    return httpClient.put(`/box/${boxId}/c_quantity`, {
      quantity
    }).then(res => res.data);
  },

  /**
   * Order product quantity
   */
  setQuantity: (productId, quantity) => {
    return httpClient.put(`/product/${productId}/quantity`, {
      quantity
    }).then(res => res.data);
  },

  /**
   * Order product quantity
   */
  setOrderBoxQuantity: (boxId, quantity) => {
    return httpClient.put(`/box/${boxId}/quantity`, {
      quantity
    }).then(res => res.data);
  },

  /**
   * Order product quantity
   */
  setRecurrence: (productId, inCart, oneShot) => {
    const endpoint = inCart ? `/product/${productId}/c_recurrence` : `/api/product/${productId}/recurrence`

    return httpClient.put(endpoint, {
      oneShot: oneShot
    }).then(res => res.data);
  },

  /**
   * Order box recurrence
   */
  setBoxRecurrence: (boxId, inCart, oneShot) => {
    const endpoint = inCart ? `/box/${boxId}/c_recurrence` : `/api/box/${boxId}/recurrence`

    return httpClient.put(endpoint, {
      oneShot: oneShot
    }).then(res => res.data);
  },

  /**
   * Set like
   */
  setLike: (productId, liked) => {
    return httpClient.put(`/product/${productId}/like`, {
      liked
    }).then(res => res.data);
  },

  /**
   * Delete
   */
  deleteProduct: (productId) => {
    return httpClient.put(`/api/product/${productId}/delete`).then(res => res.data);
  },

  /**
   * Delete
   */
  deleteBox: (boxId) => {
    return httpClient.put(`/api/box/${boxId}/delete`).then(res => res.data);
  },

  /**
   * Get products
   */
  getProducts: () => {
    return httpClient.get(`/api/products`)
      .then(res => res.data);
  },

  /**
   * Get consignes
   */
  getConsignes: () => {
    return httpClient.get(`/api/consignes`)
      .then(res => res.data);
  },

  /**
   * Get FAQs
   */
  getFaq: () => {
    return httpClient.get(`/api/faq`)
      .then(res => res.data);
  },

  /**
   * Get zones
   */
  getZones: () => {
    return httpClient.get(`/zones`)
      .then(res => res.data);
  },

  /**
   * Get zone
   */
  getZone: (zoneId) => {
    return httpClient.get(`/api/zone/${zoneId}`).then(res => res.data)
  },

  /**
   * Get zones
   */
  getCategories: () => {
    return httpClient.get(`/api/categories`)
      .then(res => res.data);
  },

  /**
   * Delivery settings
   */
  updateDeliverySettings: (accountId, status, deliveryDate) => {
    return httpClient.put(`/account/${accountId}/delivery`, {
      status, delivery_date: deliveryDate
    }).then(res => res.data);
  },

  /**
   * Delivery date
   */
  updateDeliveryDate: (accountId, deliveryDate, delivery_fee, address = null) => {
    return httpClient.put(`/account/${accountId}/delivery`, {
      delivery_date: deliveryDate,
      delivery_fee: delivery_fee,
      address: address
    }).then(res => res.data);
  },

  /**
   * Validate Cart
   */
  validateCart: () => {
    return httpClient.post(`/api/account/validate-cart`, {}).then(res => res.data)
  },

  /**
   * Validate Cart
   */
  addOrderComment: (orderComment) => {
    return httpClient.post(`/api/account/order-comment`, {orderComment}).then(res => res.data)
  },

  /**
   * Create a user
   */
  createUser: (user) => {
    return httpClient.post(`/api/account/signup`, {user}).then(res => res.data)
  },

  validateUserAddress: (user) => {
    return httpClient.post(`/api/account/address`, {user}).then(res => res.data)
  },

  /**
   * update localisation
   */
  updateLocalisation: (user) => {
    return httpClient.put(`/api/account/localization`, {user}).then(res => res.data)
  },

  /**
   * update user infos
   */
  updateUser: (user) => {
    return httpClient.put(`/api/account`, {user}).then(res => res.data)
  },

  /**
   * get today deliveries
   */
  getTodayDeliveries: () => {
    return httpClient.get(`/admin/api/deliveries`).then(res => res.data)
  },

  /**
   * Change Truck
   */
  cancelUnloading: (delivery_id) => {
    return httpClient.put(`/admin/api/cancel-unloading/${delivery_id}`, {delivery_id}).then(res => res.data)
  },

  /**
   * Change Truck
   */
  changeTruck: (orderId, deliveryTruckDayId) => {
    return httpClient.put(`/admin/api/orders/${orderId}/change-truck`, {deliveryTruckDayId}).then(res => res.data)
  },

  /**
   * Mark mercato as done
   */
  markMercatoAsDone: () => {
    return httpClient.put(`/admin/api/orders/end-mercato`, {}).then(res => res.data)
  },

  /**
   * Get mercato status
   */
  getMercatoStatus: () => {
    return httpClient.get(`/admin/api/orders/mercato-status`, {}).then(res => res.data)
  },
  /**
   * Send contact email
   */
  sendContactMessage: (name, email, message) => {
    return httpClient.post(`/api/mails/contact`, {name, email, message}).then(res => res.data)
  },

  /**
   * Send feedback email
   */
  sendFeedback: (name, email, type, message) => {
    return httpClient.post(`/api/mails/feedback`, {name, email, type, message}).then(res => res.data)
  },

  /**
   * Init OM payment
   */
  makeOMPayment: (phoneNumber, amount, otpCode) => {
    return httpClient.post(`/api/online_payment/orange/payment`, {phoneNumber, amount, otpCode}).then(res => res.data)
  },

  /**
   * Get OM Deeplink
   */
  getOMDeepLink: (amount) => {
    return httpClient.post(`/api/online_payment/orange/deep-link`, {amount}).then(res => res.data)
  },

  /**
   * get consigne
   */
  getOrderConsignes: (order_id) => {
    return httpClient.get(`/driver/${order_id}/consignes`).then(res => res.data)
  },

  getDriverOrderById: (orderId) => {
    return httpClient.get(`/driver/orders/${orderId}`)
      .then(res => res.data);
  },

  getDriverUserById: (userId) => {
    return httpClient.get(`/driver/users/${userId}`)
      .then(res => res.data);
  },

  /**
   * Update order address
   * @param {number} orderId - Order ID
   * @param {object} addressData - Address data (lat, lng, description, zone_id)
   * @returns {Promise}
   */
  updateOrderAddress: (orderId, addressData) => {
    return httpClient.patch(`/driver/orders/${orderId}/address`, {
      address: addressData
    }).then(res => res.data);
  },

  /**
   * Update order status for non-delivery reasons
   * @param {number} orderId - Order ID
   * @param {string} status - Status ('no home', 'door cancellation', 'no product', 'no cash on delivery')
   * @returns {Promise}
   */
  updateOrderStatus: (orderId, status) => {
    return httpClient.put(`/driver/orders/${orderId}/status`, {
      status: status
    }).then(res => res.data);
  },

  /**
   * get consigne
   */
  deliverOrder: (order_id, payload) => {
    return httpClient.post(`/driver/${order_id}/deliver`, payload).then(res => res.data)
  },

  /**
   * Validate Quantities
   * @param {*} order_id
   * @param {*} payload
   * @returns
   */
  deliverQuantities: (order_id, payload) => {
    return httpClient.post(`/driver/api/${order_id}/deliver-quantities`, payload).then(res => res.data)
  },

  /**
   * get consigne unloading
   */
  getConsigneUnloading: (day_id) => {
    return httpClient.get(`/driver/api/${day_id}/consigne-unloading`).then(res => res.data)
  },

  /**
   * get consigne
   */
  saveConsigneUnloading: (day_id, payload) => {
    return httpClient.post(`/driver/api/${day_id}/consigne-unloading`, payload).then(res => res.data)
  },

  /**
   * Get loading status for a delivery day
   * @param {number} day_id - DeliveryTruckDay ID
   * @returns {Promise} - { is_ready_to_delivery: boolean }
   */
  getLoadingStatus: (day_id) => {
    return httpClient.get(`/driver/api/${day_id}/loading-status`).then(res => res.data)
  },

  /**
   * get consigne unloading
   */
  getDayCash: (day_id) => {
    return httpClient.get(`/driver/api/${day_id}/cash`).then(res => res.data)
  },

  /**
   * get consigne
   */
  getLoadings: () => {
    return httpClient.get(`/admin/api/odoo/loadings`).then(res => res.data)
  },

  /**
   * Sync loading
   */
  syncLoading: () => {
    return httpClient.put(`/admin/api/odoo/loadings`, {}).then(res => res.data)
  },

  /**
   * Check if loading is synced to Odoo
   */
  checkLoadingStatus: () => {
    return httpClient.get(`/admin/api/odoo/loading-status`).then(res => res.data)
  },

  /**
   * Sync orders to Odoo
   */
  syncOrders: () => {
    return httpClient.put(`/admin/api/odoo/orders`, {}).then(res => res.data)
  },

  /**
   * Get Report
   */
    getReport: (currentDate) => {
      return httpClient.get(`/admin/api/report/summary`, {params: { current_date: currentDate } }).then(res => res.data)
    },

  /**
   * Get delivery times extraction
   */
    getDeliveryTimesExtraction: (startDate, endDate) => {
      return httpClient.get(`/admin/api/extractions/delivery-times`, {params: { start_date: startDate, end_date: endDate } }).then(res => res.data)
    },

  /**
   * Check product availability for CSV imports
   */
  checkSalesAvailability: (salesData, depotId = 'WH') => {
    return httpClient.get(`/admin/odoo/stock/${depotId}`).then(res => {
      const stockData = res.data;
      
      // Process sales data to compare with stock
      let valid = true;
      
      // Group and sum products by product code
      const productGroups = {};
      
      // First pass: group and sum quantities by product code
      salesData.forEach(sale => {
        sale.lines.forEach(line => {
          const productCode = line.product_ref;
          
          if (!productGroups[productCode]) {
            productGroups[productCode] = {
              product_code: productCode,
              name: line.product_name,
              customer_name: 'Multiple', // Will be overridden if only one customer
              sale_date: sale.sale_date,
              depot_id: sale.depot_id,
              loading_quantity: 0,
              customers: new Set(),
              dates: new Set()
            };
          }
          
          // Sum quantities
          productGroups[productCode].loading_quantity += parseFloat(line.quantity);
          
          // Track unique customers and dates
          productGroups[productCode].customers.add(sale.customer_name);
          productGroups[productCode].dates.add(sale.sale_date);
        });
      });
      
      // Convert to array and add stock information
      const processedSales = Object.values(productGroups).map(group => {
        // Find stock data for this product
        const stockItem = stockData.find(item => item.product_code === group.product_code);
        const odooQuantity = stockItem ? stockItem.qty_available : 0;
        const status = stockItem && odooQuantity >= group.loading_quantity ? 'OK' : 'STOCK INSUFFISANT';
        
        if (status !== 'OK') valid = false;
        
        // Format customer name (show single name or 'Multiple')
        const customerArray = Array.from(group.customers);
        const customerName = customerArray.length === 1 ? customerArray[0] : `${customerArray.length} clients`;
        
        // Format date (show single date or date range)
        const dateArray = Array.from(group.dates).sort();
        const saleDate = dateArray.length === 1 ? dateArray[0] : `${dateArray[0]} - ${dateArray[dateArray.length-1]}`;
        
        return {
          product_code: group.product_code,
          name: group.name,
          customer_name: customerName,
          sale_date: saleDate,
          depot_id: group.depot_id,
          loading_quantity: group.loading_quantity,
          odoo_quantity: odooQuantity,
          status: status
        };
      });
      
      return {
        valid: valid,
        products: processedSales
      };
    });
  },
  
  /**
   * Sync sales with Odoo
   */
  syncSales: (salesData) => {
    return httpClient.post('/admin/odoo/sync-sales', { sales: salesData }).then(res => res.data);
  },

  /**
   * Address management methods
   */
  getUserAddresses: (userId) => {
    return httpClient.get(`/users/${userId}/addresses`).then(res => res.data);
  },

  createUserAddress: (userId, address) => {
    return httpClient.post(`/users/${userId}/addresses`, { address }).then(res => res.data);
  },

  updateUserAddress: (userId, addressId, address) => {
    return httpClient.put(`/users/${userId}/addresses/${addressId}`, { address }).then(res => res.data);
  },

  deleteUserAddress: (userId, addressId) => {
    return httpClient.delete(`/users/${userId}/addresses/${addressId}`).then(res => res.data);
  },

  setDefaultAddress: (userId, addressId) => {
    return httpClient.patch(`/users/${userId}/addresses/${addressId}/set_default`).then(res => res.data);
  },

  /**
   * Admin address management methods
   */
  admin: {
    getUserAddresses: (userId) => {
      return httpClient.get(`/admin/clients/${userId}/addresses`).then(res => res.data);
    },

    createUserAddress: (userId, address) => {
      return httpClient.post(`/admin/clients/${userId}/addresses`, { address }).then(res => res.data);
    },

    updateUserAddress: (userId, addressId, address) => {
      return httpClient.put(`/admin/clients/${userId}/addresses/${addressId}`, { address }).then(res => res.data);
    },

    deleteUserAddress: (userId, addressId) => {
      return httpClient.delete(`/admin/clients/${userId}/addresses/${addressId}`).then(res => res.data);
    },

    setDefaultAddress: (userId, addressId) => {
      return httpClient.patch(`/admin/clients/${userId}/addresses/${addressId}/set_default`).then(res => res.data);
    }
  }

}
